import {fetchDemoRequest} from '@blesk-frontend/api';
import {useBleskAuth} from '@blesk-frontend/auth';
import {Button, cn, Input} from '@blesk-frontend/ui';
import {useForm} from 'react-hook-form';
import {toast} from 'sonner';

export const DemoRequestFrom = () => {
  const {
    query: {data: user},
  } = useBleskAuth();
  const {
    register,
    handleSubmit,

    formState: {errors, isValid, isSubmitting},
  } = useForm<{userId: string; contact: string}>({
    defaultValues: {userId: user?.id},
  });

  const onClickDemoRequest = handleSubmit(async (data) => {
    if (data.contact && /[a-zA-Z@]/.test(data.contact)) {
      await fetchDemoRequest({telegram: data.contact});
    } else {
      await fetchDemoRequest({phone: data.contact});
    }
    toast.success('Заявка отправлена');
  });
  return (
    <div className="flex max-w-2xl flex-col gap-4 rounded-lg border p-6">
      <div className="flex items-center gap-2 text-text-primary text-title-h2">
        Покажем как работает Blesk
      </div>
      <p className="text-text-secondary">
        Закажите короткую демонстрацию. На звонке мы покажем, как за пару минут создавать пошаговые
        инструкции и использовать их для обучения, поддержки и документации. Без продаж, только
        польза.
      </p>
      <form onSubmit={onClickDemoRequest} className="flex items-center gap-4">
        <Input
          placeholder="Укажите телефон или телеграм"
          className={cn('w-80', errors.contact && 'border-b-error-primary')}
          {...register('contact', {
            required: true,
            pattern: {
              value: /^(^@?[a-zA-Z0-9_]{5,32}$|^(?=(?:.*\d){11,})[\d\s\-()+]+$)$/,
              message: 'Неверный формат телефона или телеграм',
            },
            validate: (value) => {
              if (!value) {
                return 'Укажите телефон или телеграм';
              }
              return true;
            },
          })}
        />
        <Button
          type="submit"
          variant="primary"
          onClick={onClickDemoRequest}
          disabled={!isValid}
          loading={isSubmitting}
        >
          Записаться на демо
        </Button>
      </form>
    </div>
  );
};
